import React, { useState } from "react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ParallaxStory from "@/components/ParallaxStory";
import EnquiryDialog from "@/components/EnquiryDialog";

export default function MusicRoom() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Navigation />
      <ParallaxStory images={["/img/music-room.jpg"]} testid="music-room-page">
        <p className="font-display text-xl md:text-2xl text-parchment leading-relaxed">
          Rehearsal Room — £25 per hour — Schiedmayer grand piano, library of sheet
          music, and artist use of bathroom.
        </p>
        <p className="font-display text-xl md:text-2xl text-parchment leading-relaxed mt-6">
          Ground Floor — by{" "}
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="font-bold hover:text-parchment/80 transition-colors"
            data-testid="musicroom-enquire-link"
          >
            enquiry
          </button>{" "}
          — self-catering kitchen and facilities for an audience, shoot or larger group (up to 40).
        </p>
      </ParallaxStory>
      <EnquiryDialog open={open} onClose={() => setOpen(false)} />
      <Footer />
    </>
  );
}
